type EventCallback = (...args: any[]) => void

class EventBus {
	private events: Record<string, EventCallback[]> = {}

	subscribe(event: string, callback: EventCallback): () => void {
		if (!this.events[event]) {
			this.events[event] = []
		}

		this.events[event].push(callback)

		return () => {
			this.unsubscribe(event, callback)
		}
	}

	unsubscribe(event: string, callback: EventCallback): void {
		if (this.events[event]) {
			this.events[event] = this.events[event].filter((cb) => cb !== callback)
		}
	}

	publish(event: string, ...args: any[]): void {
		if (this.events[event]) {
			this.events[event].forEach((callback) => callback(...args))
		}
	}
}

// Create a singleton instance
const eventBus = new EventBus()
export default eventBus
